import { useLingui } from '@lingui/react'
import { Chip } from '@mui/material'

import { PatientIdentityStatus } from '@/core/models/patient.model'
import { PATIENT_IDENTITY_STATUS_LABELS, getIdentityStatusColor } from '@/pages/patient/lib/patient-identity-status'

export type IdentityStatusBadgeProps = {
  status?: PatientIdentityStatus
}

export function IdentityStatusBadge({ status }: IdentityStatusBadgeProps) {
  const { i18n } = useLingui()

  if (!status) {
    return null
  }

  return (
    <Chip
      label={i18n._(PATIENT_IDENTITY_STATUS_LABELS[status])}
      color={getIdentityStatusColor(status)}
      size="small"
    />
  )
}
